import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

import { Axis, Chart, Interaction, Point, Tooltip } from 'bizcharts';
import DownloadButton from "../Common/DownloadButton";


const ScatterDotsChart = (props) => {

    const [data, setData] = useState([]);
    const [height, setHeight] = useState(500);

    const csv = props.csv;
    const filter = props.filter;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                const filtered = results.data.filter(d => d['Food commodity'] === filter).sort((a, b) => { return a['Pesticide'] < b['Pesticide'] ? 1 : -1 });
                setData(filtered);
                setHeight(filtered.length * 25);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, [csv, filter]);

    const [canvas, setCanvas] = useState(undefined);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })
    return (
        <Box>

            {data.length > 0 &&
                <Box>
                    <Box display='flex' justifyContent='space-between'>
                        <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '.5rem' }}>{props.title}</p>
                        <DownloadButton canvas={canvas} fileName={props.title} csv={data} />
                    </Box>

                    <Chart
                        padding={isMobile ? [0, 0, 20, 210] : [0, 100, 20, 250]}
                        height={height}
                        data={data}
                        forceFit
                        autoFit
                        interactions={['legend-highlight']}
                        onGetG2Instance={chartInstance => {
                            setCanvas(chartInstance.canvas);
                        }}
                    >
                        <Point
                            position="Percentage of the value of the Pesticides MRL*Pesticide"
                            color="#00B289"
                            shape="circle"
                            tooltip={[
                                'Percentage of the value of the Pesticides MRL*Pesticide',
                                (percent, pecticide) => {
                                    return {
                                        pesticide: pecticide + ': ' + percent + '%',
                                    };
                                }
                            ]}
                            style={{
                                fillOpacity: 0.85
                            }} />
                        <Axis name="Percentage of the value of the Pesticides MRL" label={{
                            style: {
                                fontFamily: 'Roboto Condensed, sans-serif'
                            },
                            formatter: (a) => {
                                return a + '%'
                            }
                        }} />
                        <Axis name="Pesticide" label={{
                            style: {
                                fontFamily: 'Roboto Condensed, sans-serif'
                            }
                        }} />

                        <Tooltip showTitle={false}
                            crosshairs={{ type: 'y' }}
                            itemTpl={'<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;">'
                                + '<span style="background-color:{color};" class="g2-tooltip-marker"></span>'
                                + '<span style="padding-left: 16px">Pesticide: {pesticide}</span><br/>'
                                + '</li>'}
                            showCrosshairs />
                    </Chart>
                </Box>
            }
            {data.length === 0 &&
                <Box display='flex' justifyContent='center'>
                    <p style={{
                        color: 'white',
                        fontWeight: '700',
                        maxWidth: '280px',
                        textAlign: 'center',
                        fontSize: '14px',
                        backgroundColor: '#00B289',
                        padding: '0 10px 0 10px'
                    }}>No residues {props.residuesActive === 0 ? " below 100% " : " above 100% "} as percentage of MRL were reported to this food product.</p>
                </Box>
            }
        </Box>

    );

}

export default ScatterDotsChart;